import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { HardHat, CheckCircle2, Zap } from "lucide-react";
import { toast } from "sonner";

export default function SetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    publicApi.get(`/auth/invite/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Ongeldige uitnodiging"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Wachtwoord minimaal 8 tekens");
    if (pw !== pw2) return toast.error("Wachtwoorden komen niet overeen");
    setSaving(true);
    try {
      await publicApi.post("/auth/set-password", { token, password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kon wachtwoord niet instellen");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      <header className="border-b-4 border-orange-600 bg-slate-900 shadow-[0_4px_0_rgba(0,0,0,0.4)]">
        <div className="max-w-4xl mx-auto px-4 h-20 flex items-center">
          <Link to="/" className="flex items-center">
            <img src="/logo-ploegbord.webp?v=8" alt="Ploegbord" className="h-12 md:h-14 w-auto"/>
          </Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="pb-card !bg-white !text-slate-900 p-6 max-w-md w-full" data-testid="set-password-page">
          {err && (
            <>
              <div className="pb-heading text-2xl font-black">Uitnodiging ongeldig</div>
              <div className="mt-2 text-slate-600 font-semibold">{err}</div>
              <Link to="/" className="pb-btn-outline mt-4 inline-block">Terug</Link>
            </>
          )}
          {!err && !info && <div className="text-slate-600">Laden…</div>}
          {info && !done && (
            <>
              <div className="text-orange-600 text-xs font-black uppercase tracking-widest">Welkom bij Ploegbord</div>
              <div className="pb-heading text-2xl font-black mt-1">Hoi {info.name.split(" ")[0]}!</div>
              <p className="mt-2 text-slate-600 font-semibold text-sm">
                Je bent uitgenodigd door <span className="font-black">{info.company_name}</span> als <span className="font-black">{info.role}</span>. Stel eerst je wachtwoord in — daarna kun je inloggen met <span className="font-black">{info.email}</span>.
              </p>
              <form onSubmit={submit} className="mt-4 space-y-3">
                <label className="block">
                  <span className="text-xs font-black uppercase tracking-widest">Nieuw wachtwoord</span>
                  <input type="password" className="pb-input mt-1" required minLength={8} value={pw} onChange={(e)=>setPw(e.target.value)} data-testid="sp-pw" placeholder="min. 8 tekens" autoFocus/>
                </label>
                <label className="block">
                  <span className="text-xs font-black uppercase tracking-widest">Herhaal wachtwoord</span>
                  <input type="password" className="pb-input mt-1" required minLength={8} value={pw2} onChange={(e)=>setPw2(e.target.value)} data-testid="sp-pw2"/>
                </label>
                <button type="submit" disabled={saving} className="pb-btn-primary w-full !min-h-[48px] flex items-center justify-center gap-2" data-testid="sp-submit">
                  <Zap size={18}/> {saving ? "Instellen…" : "Wachtwoord instellen"}
                </button>
              </form>
            </>
          )}
          {done && (
            <>
              <div className="w-14 h-14 rounded-full bg-orange-600 text-white flex items-center justify-center mx-auto"><CheckCircle2 size={28}/></div>
              <div className="pb-heading text-xl font-black text-center mt-3">Klaar!</div>
              <div className="text-center text-slate-600 font-semibold mt-1 text-sm">Je wordt zo doorgestuurd naar het inlogscherm.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
